import {combineReducers} from 'redux';
import {productDetail} from '../pages/productdetail/storeModel/reducer';
import {productPrice} from '../pages/productPrice/storeModel/reducer';
import {insuranceSettleReducer} from '../pages/insuranceSettle/storeModel/reducer';
import {insuranceInfoReducer} from '../pages/insuranceInfo/storeModel/reducer';
import {insuranceItemsInfo} from '../pages/floatInfo/storeModel/reducer'
import {specialContentInfo} from '../pages/specialContent/storeModel/reducer'
import {reRepayInfo} from '../pages/insuranceFailed/storeModel/reducer'
import {agentLoginReducer} from "../pages/agentLogin/storeModel/reducer";
import {orderInfoReducer} from "../pages/order/storeModel/reducer";
import {handSignReducer} from "../pages/sign/storeModel/reducer";
import {IdentityCheckReducer} from "../pages/customerIdentity/storeModel/reducer";
import { protocolValidationInfo } from "../pages/protocolValidation/storeModel/reducer";
import { globalReducer } from '@/reducers/global';

export const rootReducer = combineReducers({
    productDetail,
    productPrice,
    insuranceSettleReducer,
    insuranceInfoReducer,
    insuranceItemsInfo,
    specialContentInfo,
    reRepayInfo,
    agentLoginReducer,
    orderInfoReducer,
    handSignReducer,
    IdentityCheckReducer,
    protocolValidationInfo,
    globalReducer,
});
